import fermentedMilkCategoryCoverImage from '../../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImage.webp'
import fermentedMilkCategoryCoverImageMobile from '../../../assets/images/fermentedMilkProducts/fermentedMilkCategoryCoverImageMobile.webp'
import sourCreamPastoral1 from '../../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-200g.webp'
import sourCreamPastoral2 from '../../../assets/images/fermentedMilkProducts/sour-cream-30-fat-pastoral-400g.webp'
import kefirMumulya1 from '../../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-400g.webp'
import kefirMumulya2 from '../../../assets/images/fermentedMilkProducts/kefir-1-fat-mumulya-900g.webp'
import kefirMumulya3 from '../../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-400g.webp'
import kefirMumulya4 from '../../../assets/images/fermentedMilkProducts/kefir-2-5-fat-mumulya-900g.webp'
import sourCreamMumulya1 from '../../../assets/images/fermentedMilkProducts/sour-cream-15-fat-mumulya-400g.webp'
import sourCreamMumulya2 from '../../../assets/images/fermentedMilkProducts/sour-cream-20-fat-mumulya-400g.webp'
import yogurtPeach1 from '../../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-400g.webp'
import yogurtPeach2 from '../../../assets/images/fermentedMilkProducts/yogurt-peach-2-5-fat-mumulya-115g.webp'
import yogurtStrawberry1 from '../../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-400g.webp'
import yogurtStrawberry2 from '../../../assets/images/fermentedMilkProducts/yogurt-strawberry-2-5-fat-mumulya-115g.webp'
import yogurtForestBerries1 from '../../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-400g.webp'
import yogurtForestBerries2 from '../../../assets/images/fermentedMilkProducts/yogurt-forest-berries-2-5-fat-mumulya-115g.webp'



export const FermentedMilkProductsArr = [
    {
        path: "/fermented-milk-products/sour-cream-30-fat-pastoral-200g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 30% жиру ТМ «Pastoral» 200 g (г)",
        metaDescription: "Сметана 30% жиру ТМ «Pastoral» 200 g (г)",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: sourCreamPastoral1,
        aboutTitle: "Сметана 30% жиру ТМ «Pastoral» 200 g (г)",
        aboutStats: [
            "2,4 g (г)", "30,0 g (г)", "2,7 g (г)", "294 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "200 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Cтакан",
            },
            {
                title: "Склад: ",
                desc: "вершки з коров’ячого молока, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>Від дати виробництва  при температурі  4±2 оС не більше ніж 21 доба.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/sour-cream-30-fat-pastoral-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 30% жиру ТМ «Pastoral» 400 g",
        metaDescription: "Сметана 30% жиру ТМ «Pastoral» 400 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: sourCreamPastoral2,
        aboutTitle: "Сметана 30% жиру ТМ «Pastoral» 400 g (г)",
        aboutStats: [
            "2,4 g (г)", "30,0 g (г)", "2,7 g (г)", "294 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Фольга",
            },
            {
                title: "Склад: ",
                desc: "вершки з коров’ячого молока, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>Від дати виробництва  при температурі  4±2 оС не більше ніж 21 доба</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/kefir-1-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Кефір 1,0 % жиру ТМ «МУМУЛЯ»",
        metaDescription: "Кефір 1,0 % жиру ТМ «МУМУЛЯ»",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: kefirMumulya1,
        aboutTitle: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "1,0 g (г)", "3,5 g (г)", "39 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров’яче незбиране, молоко коров’яче знежирене, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі 4±2° С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/kefir-1-fat-mumulya-900g/",
        category: "fermentedMilk",
        metaTitle: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 900 g",
        metaDescription: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 900 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: kefirMumulya2,
        aboutTitle: "Кефір 1,0 % жиру ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "1,0 g (г)", "3,5 g (г)", "39 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "900 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров’яче незбиране, молоко коров’яче знежирене, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі 4±2° С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/kefir-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 400 g",
        metaDescription: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 400 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: kefirMumulya3,
        aboutTitle: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "3,5 g (г)", "53 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров’яче незбиране, молоко коров’яче знежирене, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі 4±2° С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/kefir-2-5-fat-mumulya-900g/",
        category: "fermentedMilk",
        metaTitle: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 900 g",
        metaDescription: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 900 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: kefirMumulya4,
        aboutTitle: "Кефір 2,5 % жиру ТМ «МУМУЛЯ» 900 g (г)",
        aboutStats: [
            "3,0 g (г)", "2,5 g (г)", "3,5 g (г)", "53 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "900 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров’яче незбиране, молоко коров’яче знежирене, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>при температурі 4±2° С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-011-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/sour-cream-15-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 15 % жиру ТМ «МУМУЛЯ» 400 g",
        metaDescription: "Сметана 15 % жиру ТМ «МУМУЛЯ» 400 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: sourCreamMumulya1,
        aboutTitle: "Сметана 15 % жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "3,0 g (г)", "15,0 g (г)", "3,0 g (г)", "159 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "вершки з коров’ячого молока, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>Від дати виробництва при температурі  4±2 оС не більше ніж 21 доба.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/sour-cream-20-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Сметана 20 % жиру ТМ «МУМУЛЯ» 400 g",
        metaDescription: "Сметана 20 % жиру ТМ «МУМУЛЯ» 400 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: sourCreamMumulya2,
        aboutTitle: "Сметана 20 % жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,8 g (г)", "20,0 g (г)", "3,0 g (г)", "212,2 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "вершки з коров’ячого молока, закваска бактеріальна. Загальна кількість життєздатних молочнокислих бактерій не менше ніж 1×107 КУО в 1 см3.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>Від дати виробництва при температурі  4±2 оС не більше ніж 21 доба.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ У 25027034-009-99",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-peach-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ»",
        metaDescription: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ»",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtPeach1,
        aboutTitle: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко  коров'яче незбиране, молоко  коров'яче знежирене , цукор-пісок, фруктовий наповнювач пастеризований «Персик» (цукор білий кристалічний - 54%, персик - 35%, модифікований крохмаль Е1442 (кукурудзяний), регулятор кислотності цитрат натрію Е331, ароматизатор «персик», барвник бета-каротин Е160а), молоко сухе знежирене, бактеріальна закваска для йогурту.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-peach-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками персика",
        metaDescription: "Йогурт зі шматочками персика",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtPeach2,
        aboutTitle: "Йогурт зі шматочками персика 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "115 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "стакан",
            },
            {
                title: "Склад: ",
                desc: "молоко  коров'яче незбиране, молоко  коров'яче знежирене , цукор-пісок, фруктовий наповнювач пастеризований «Персик» (цукор білий кристалічний - 54%, персик - 35%, модифікований крохмаль Е1442 (кукурудзяний), регулятор кислотності цитрат натрію Е331, ароматизатор «персик», барвник бета-каротин Е160а), молоко сухе знежирене, бактеріальна закваска для йогурту.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-strawberry-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками полуниці 2,5% жиру",
        metaDescription: "Йогурт зі шматочками полуниці 2,5% жиру",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtStrawberry1,
        aboutTitle: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров'яче незбиране, молоко коров'яче знежирене , цукор-пісок, наповнювач фруктовий пастеризований «Полуниця» (цукор білий кристалічний - 42%, полуниця - 40%, модифікований крохмаль (кукурудзяний) Е1442, пектин Е1440, регулятори кислотності: лимонна кислота Е330 та цитрат натрію Е331, ароматизатори: полуниця та ваніль, барвники: сік червоного буряка відновлений, кармін Е120), молоко сухе знежирене,  бактеріальна закваска для йогурту",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-strawberry-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 115 g",
        metaDescription: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 115 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtStrawberry2,
        aboutTitle: "Йогурт зі шматочками полуниці 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "115 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "стакан",
            },
            {
                title: "Склад: ",
                desc: "молоко коров'яче незбиране, молоко коров'яче знежирене , цукор-пісок, наповнювач фруктовий пастеризований «Полуниця» (цукор білий кристалічний - 42%, полуниця - 40%, модифікований крохмаль (кукурудзяний) Е1442, пектин Е1440, регулятори кислотності: лимонна кислота Е330 та цитрат натрію Е331, ароматизатори: полуниця та ваніль, барвники: сік червоного буряка відновлений, кармін Е120), молоко сухе знежирене,  бактеріальна закваска для йогурту.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб.</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-forest-berries-2-5-fat-mumulya-400g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 400 g",
        metaDescription: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 400 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtForestBerries1,
        aboutTitle: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 400 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "400 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "Плівка п/е",
            },
            {
                title: "Склад: ",
                desc: "молоко коров'яче незбиране, молоко коров'яче знежирене, цукор-пісок, фруктовий наповнювач пастеризований «Лісова ягода» (цукор білий кристалічний 53%, фрукти – 35% (ожина, малина, полуниця, чорниця, чорна смородина), модифікований крохмаль Е1442, регулятори кислотності: лимонна кислота Е330 та цитрат натрію Е331, ароматизатор полуниці, барвник кармін Е120), молоко сухе знежирене, бактеріальна закваска для йогурту.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ДСТУ 4343:2004",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    {
        path: "/fermented-milk-products/yogurt-forest-berries-2-5-fat-mumulya-115g/",
        category: "fermentedMilk",
        metaTitle: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 115 g",
        metaDescription: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 115 g",
        coverImage: fermentedMilkCategoryCoverImage,
        coverImageMobile: fermentedMilkCategoryCoverImageMobile,
        coverTitle: "Кисломолочні продукти",
        aboutImage: yogurtForestBerries2,
        aboutTitle: "Йогурт зі шматочками лісових ягод 2,5% жиру ТМ «МУМУЛЯ» 115 g (г)",
        aboutStats: [
            "2,75 g (г)", "2,5 g (г)", "10,78 g (г)", "76,62 kcal (ккал)"
        ],
        aboutLink: "",
        aboutInformation: [
            {
                title: "Маса/Об'єм: ",
                desc: "115 g (г)",
            },
            {
                title: "Пакування: ",
                desc: "стакан",
            },
            {
                title: "Склад: ",
                desc: "молоко коров'яче незбиране, молоко коров'яче знежирене, цукор-пісок, фруктовий наповнювач пастеризований «Лісова ягода» (цукор білий кристалічний 53%, фрукти – 35% (ожина, малина, полуниця, чорниця, чорна смородина), модифікований крохмаль Е1442, регулятори кислотності: лимонна кислота Е330 та цитрат натрію Е331, ароматизатор полуниці, барвник кармін Е120), молоко сухе знежирене, бактеріальна закваска для йогурту.",
            },
            {
                title: "Термін придатності: ",
                desc: (
                    <>від дати виробництва при температурі (4±2)°С не більше ніж 14 діб</>
                ),

            },
            {
                title: "Сертифікат якості: ",
                desc: "ТУ 15.5.25027034-019-01",
            },
        ],
        categoryInfo: [
            "Контроль всіх процесів виробництва та делікатний процес сквашування.",
            "Бактеріальна закваска від європейського виробника.",
            "Натуральне джерело білку, кальцію та корисних молочно-кислих культур.",
            "Густа консистенція, оксамитова текстура, ніжний вершковий смак з легкою кислинкою.",
    
        ],
    },
    
]